// App version - 6.6 for Jun 2026
export const APP_VERSION = '6.6';
export const APP_CODENAME = 'Pisces';
export const APP_NAME = 'Creative Queue';
